import trtEnhancedInitialQuestions from './initial/Enhanced/questions';
import trtFollowupQuestions from './followup/questions';
import trtEnhancedFollowupQuestions from './followup/Enhanced/questions';

const trtQuestions = [...trtEnhancedInitialQuestions, ...trtFollowupQuestions, ...trtEnhancedFollowupQuestions];
export default trtQuestions;

export type { TRTEnhancedQuestionFieldAnswers } from './initial/Enhanced/questions';
export type { TrtFollowupFieldAnswers } from './followup/questions';
export type { TrtEnhancedFollowupQuestionFieldAnswers } from './followup/Enhanced/questions';
